const memberQueryKeys = ["q", "status", "period", "bookingStatus", "bookingSearch"];

export function memberBookingsPath(userId: string, params: URLSearchParams) {
  const next = new URLSearchParams({ tab: "bookings" });
  for (const key of memberQueryKeys) {
    const value = params.get(key);
    if (value) next.set(key, value);
  }
  return `/admin/members/${encodeURIComponent(userId)}?${next.toString()}`;
}

/** Only return to this member's local record; never trust a caller-provided URL. */
export function memberRosterReturn(userId: string, requested: string | null) {
  const fallback = memberBookingsPath(userId, new URLSearchParams());
  if (!requested) return fallback;
  try {
    const url = new URL(requested, "https://admin.invalid");
    if (url.origin !== "https://admin.invalid" || url.pathname !== `/admin/members/${encodeURIComponent(userId)}`) return fallback;
    return memberBookingsPath(userId, url.searchParams);
  } catch {
    return fallback;
  }
}
